import script from "./MyCollectionDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./MyCollectionDetail.vue?vue&type=script&setup=true&lang=js"

import "./MyCollectionDetail.vue?vue&type=style&index=0&id=85f289a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85f289a6"]])

export default __exports__